/* eslint-disable id-blacklist */
import { Component, OnInit, Input } from '@angular/core';
import { Clipboard } from '@capacitor/clipboard';
import { ToastController } from '@ionic/angular';

@Component({
  selector: 'app-copy',
  templateUrl: './copy.component.html',
  styleUrls: ['./copy.component.scss'],
})
export class CopyComponent implements OnInit {
  @Input() textCopy: string;

  constructor(private toastController: ToastController) {}

  ngOnInit() {}

  async copyToClipboard() {
    if (!this.textCopy) {
      return;
    }

    await Clipboard.write({
      string: this.textCopy,
    });
    this.presentToast(`Successfully copy ${this.textCopy} to clipboard`);
  }

  protected async presentToast(message: string, duration: number = 1000): Promise<void> {
    const toast = await this.toastController.create({
      message,
      duration,
      mode: 'ios',
    });
    return await toast.present();
  }
}
